<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar etapa do modelo"
             col-md="col-md-5" offset="3">
    <template v-slot:modalContent>
      <form @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label><strong>Etapa: <span class="text-danger font-bold">*</span></strong></label>
              <p class="font-bold"> {{ dado.etapa_exibicao }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label><strong>Modelo: <span class="text-danger font-bold">*</span></strong></label>
              <p class="font-bold"> {{ dado.modelo_exibicao }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicio" dateFormat="dd/mm/yyyy"/>
                <label for="data_inicio"><strong>Data de Inicio: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino_previsao" v-model="dado.data_termino_previsao" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTerminoPrevisao"
                            dateFormat="dd/mm/yyyy"/>
                <label for="data_termino_previsao"><strong>Previsão Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_termino" v-model="dado.data_termino" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataTermino" dateFormat="dd/mm/yyyy"/>
                <label for="data_termino"><strong>Data de Término: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="observacao" v-model="dado.observacao" size="small" style="width: 100%"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates, normalizeDates} from "../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import moment from "moment";

export default {
  name: "EditarModeloEtapa",
  props: {
    itemKey: String,
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      dado: 1,
      erro: null,
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.modelos.etapaRetrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        normalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_termino', 'data_termino_previsao']);
      const resultado = await apiRequest("PATCH", apiUrl.modelos.etapaRetrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        ['data_inicio', 'data_termino', 'data_termino_previsao'].forEach(field => {
          if (resultado.data[field] != null) {
            resultado.data[field] = moment(resultado.data[field]).format('DD/MM/YYYY')
          }
        });
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    Inputmask("99/99/9999").mask(this.$refs.dataInicio.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTerminoPrevisao.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataTermino.$el.querySelector("input"));
  },
}
</script>
